<template>
  <div class="critical container" v-loading.fullscreen.lock="fullLoading">
    <el-tooltip
      placement="top"
      content="请提交所有错误句子后再点击下一步哦！"
      :disabled="canSubmit"
    >
      <el-button
        class="next-btn"
        type="primary"
        @click="canSubmit && (hasNext ? next(STEP.five) : handleAllSubmit())"
        :class="{ disabled: loading || !canSubmit }"
      >
        {{ hasNext ? '下一步' : '提交' }}
      </el-button>
    </el-tooltip>
    <div class="operate-bar">
      <el-button
        class="batch-submit"
        type="primary"
        @click="batchSubmit"
        :disabled="!multiSelection?.length"
      >
        批量提交
      </el-button>
    </div>
    <div class="table-wrap">
      <el-table
        border
        v-loading="loading"
        :span-method="arraySpanMethod"
        :data="records"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="位置信息" width="150">
          <template slot-scope="scope">{{ scope.row.clusterName }}</template>
        </el-table-column>
        <!-- <el-table-column
          type="index"
          label="相似句序号"
          width="150"
          :index="(idx) => (page.current - 1) * 10 + (idx + 1)"
        /> -->
        <el-table-column
          label="原文"
          class-name="critical-custom-column rich-text-column"
          width="450"
        >
          <template slot-scope="scope" v-if="scope.row && !loading">
            <ul class="critical-list">
              <li
                :class="[
                  scope.row.detailVoList.length > 1
                    ? 'li-border-b d-f align-c'
                    : 'd-f align-c',
                  item.qcStatus === submitStatusEnum.done && 'submit',
                ]"
                v-for="(item, index) in scope.row.detailVoList"
                v-if="
                  scope.row.tarLimit === 'infinite' ||
                  index < scope.row.tarLimit
                "
                :key="index"
              >
                <div class="w-450">
                  <rich-text :pId="item.id" :jsonText="item.srcText" readonly />
                </div>
                <div class="loose">
                  <rich-text
                    :pId="item.id"
                    :key="`${item.id}-${item.updateSign}`"
                    :hasToolbar="item.useRichText"
                    :ref="'richText-' + item.id"
                    :class="{
                      'edit-un-submit':
                        item.editedText !== item.oriText &&
                        item.qcStatus !== submitStatusEnum.done,
                    }"
                    :jsonText="item.qcText"
                    :errors="item.errors"
                    @change="(text, json) => handleChange(text, json, item)"
                    @focus="handleFocus"
                    @blur="(text, json) => handleBlur(text, json, item)"
                  />
                </div>
                <div class="w-150">
                  <el-button type="primary" @click="handleSubmit(item)">
                    {{ item.qcStatus === submitStatusEnum.done ? '已提交' : '提交' }}
                  </el-button>
                </div>
              </li>
            </ul>
            <div
              class="t-c p-tb-5"
              v-if="scope.row?.detailVoList.length > LIMIT"
            >
              <span class="c-p c-primary" @click="changeShowAll(scope.row)">
                {{ scope.row.showAll ? '收起' : '展开全部关键位置的句子' }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="译文" />
        <el-table-column width="150" align="center" label="操作" />
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="page.current"
        :total="page.total"
        :page-size="page.size"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getCritical,
  modifyCritical,
  batchModifyCritical,
} from '@/api/qc/check';
import RichText, { jsonTextToText } from '@/components/rich-text';
import loadAndCheckMixin from './loadAndCheckMixin.js';
import { hasValidChar } from '@/util/string';

const LIMIT = 3;
export default {
  data() {
    return {
      LIMIT,
      expandStatus: {},
    };
  },
  name: 'critical',
  // ⚠️：部分公共逻辑在mixin中！
  mixins: [loadAndCheckMixin],
  components: { RichText },
  computed: {
    hasNext() {
      return this.flowCount > 5;
    },
  },
  methods: {
    // 表格合并列
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        return [1, 3];
      } else if (columnIndex === 3) {
        return [0, 0];
      }
    },

    changeShowAll(row) {
      row.showAll = !row.showAll;
      if (row.showAll) {
        row.tarLimit = 'infinite';
      } else {
        row.tarLimit = LIMIT;
      }
    },

    handleAllSubmit() {
      this.$confirm('确认要提交吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.next(this.STEP.five);
        })
        .catch(() => {});
    },
    fetchListData() {
      this.loading = true;
      getCritical({
        current: this.page.current,
        size: this.page.size,
        orderId: this.queryParams.id,
      }).then((res) => {
        this.loading = false;
        const usableData = res.data?.data ?? {};
        this.page.total = usableData.total;
        // 是否可以提交
        this.canSubmit = usableData.hitCount;
        this.records = usableData.records
          ?.map((item) => {
            // 自定义的字段需要额外添加，防止丢失响应式
            item.detailVoList = item?.detailVoList.map((sent) => ({
              ...sent,
              editedText: sent.qcText && jsonTextToText(sent.qcText),
              // qcText 是jsonStr类型，这里需要转成text类型，用于比对
              oriText: sent.qcText && jsonTextToText(sent.qcText),
              errors: [],
              editedJson: sent.qcText,
              updateSign: 0,
            }));
            return item;
          })
          .map((item) => {
            return { ...item, showAll: false, tarLimit: LIMIT };
          });
      });
    },
    silentFetchListData() {
      getCritical({
        current: this.page.current,
        size: this.page.size,
        orderId: this.queryParams.id,
      }).then((res) => {
        const usableData = res.data?.data ?? {};
        this.page.total = usableData.total;
        // 是否可以提交
        this.canSubmit = usableData.hitCount;
      });
    },
    handleSubmit(item) {
      const isDigitMatched = this.sentDigitCheck(item);
      if (!isDigitMatched) return;

      if (!hasValidChar(item.editedText)) {
        this.$confirm(
          '<h4>确定要将此句译文保存为空吗?</h4><div>请谨慎操作！译文为空的场景一般应用于原文断句异常时，已将此句的译文合并入其他句子中。</div>',
          '译文为空预警',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(() => {
            this.doSubmit(item);
          })
          .catch(() => {
            item.editedText = item.qcText && jsonTextToText(item.qcText);
            item.editedJson = item.qcText;
            item.errors = item.errors ?? [];
            item.updateSign++;
          });
      } else {
        this.doSubmit(item);
      }
    },
    doSubmit(item) {
      modifyCritical({
        orderId: this.queryParams.id,
        id: item.id,
        srcTxt: item.srcText,
        qcTxt: item.editedJson,
      })
        .then(() => {
          this.$message({
            message: '提交成功',
            type: 'success',
          });
          item.qcStatus = this.submitStatusEnum.done;
          this.silentFetchListData();
        })
        .catch((err) => {
          if (err.message === '该质控任务状态已修改') {
            this.$closeAndGoBack();
          }
        });
    },
    handleSelectionChange(val) {
      let selection = [];
      val.forEach(
        (item) => (selection = selection.concat(item.detailVoList ?? [])),
      );
      this.multiSelection = selection;
    },
    batchSubmit() {
      if (!this.multiSelection?.length) return;
      this.batchSubmitCheck()
        .then(() => {
          this.fullLoading = true;
          batchModifyCritical(
            this.multiSelection.map((item) => ({
              id: item.id,
              orderId: this.queryParams.id,
              srcTxt: item.srcText,
              qcTxt: item.editedJson,
            })),
          )
            .then(() => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              this.fetchListData();
            })
            .catch((err) => {
              if (err.message === '该质控任务状态已修改') {
                this.$closeAndGoBack();
              }
            })
            .finally(() => {
              this.fullLoading = false;
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.critical {
  .fake-table-row {
    padding: 10px;
    &:not(:last-of-type) {
      border-bottom: 1px solid #ebeef5;
    }
  }

  .rich-text-column {
    .fake-table-row {
      padding: 0;
    }
  }
}

:deep(.el-table__body-wrapper) {
  .el-table_1_column_3,
  .el-table_1_column_4 {
    padding: 0;
    .cell {
      padding: 0;
    }
  }
}

:deep(td.critical-custom-column) {
  padding: 0;
  .cell {
    padding: 0;
  }
}

.critical-list {
  .li-border-b {
    border-bottom: 1px solid #ebeef5;
  }
  li {
    padding: 0;
    display: flex;
    align-items: stretch;
    &.submit {
      background: #f0f9eb;
    }
    > div {
      display: flex;
      align-items: center;
      padding: 8px 10px;
      border-right: 1px solid #ebeef5;
      &.loose {
        flex: 1;
        > div {
          width: 100%;
        }
      }
    }
  }
}
</style>
